/* eslint-disable prettier/prettier */
import { Box, IconButton, Tooltip, Chip, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TagIcon from "@mui/icons-material/Tag";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
// import VideoPreviewer from "src/components/shared/atoms/VideoPreviewer";
import AddLabels from "./generalLabels";
import UpdateLabel from "./list/updateLabel";
import useStyles from "./Styles";

const Labels = () => {
  const { classes } = useStyles();

  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode");
  const location = useLocation();
  const { labelData } = location?.state ?? {};

  const navigate = useNavigate();

  const handleCancel = () => {
    navigate("/settings/label");
  };
  return (
    <Box className={classes.root}>
      <Box className={classes.headerContainer}>
        <Box className={classes.box}>
          <Typography className={classes.boxText}>Labels | Tags</Typography>
          {/* <VideoPreviewer videoId="ELf2MlpUUNY" /> */}
        </Box>

        <Box sx={{ display: "flex", gap: "5px" }}>
          {mode === "edit" && (
            <Tooltip title="go back">
              <IconButton
                onClick={handleCancel}
                color="primary"
                className={classes.backButton}
              >
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
          )}
          <Chip
            icon={<TagIcon fontSize="small" />}
            label={mode === "edit" ? "Editing Label" : "Adding Label"}
            variant="outlined"
            className={classes.labelActionStyle}
          />
        </Box>
      </Box>

      {mode === "edit" ? <UpdateLabel labelData={labelData} /> : <AddLabels />}
    </Box>
  );
};

export default Labels;
